import Logger from "@home-gallery/logger";
class ExtensionRegistry {
  extensionsEntries = [];
  schemas;
  disabledExtensions;
  log = Logger("extensionRegistry");
  constructor(schemas = {}, disabledExtensions = []) {
    this.schemas = schemas;
    this.disabledExtensions = disabledExtensions;
  }
  async register(plugin, type, extension) {
    if (!extension?.name) {
      throw new Error(`Plugin extension of type ${type} has no name of plugin ${plugin.name}`);
    }
    if (this.disabledExtensions.includes(`${plugin.name}.${extension.name}`)) {
      this.log.info(`Plugin extension ${plugin.name}.${extension.name} is disabled. Skip extension registration`);
      return;
    }
    const schema = this.schemas[type];
    if (!schema) {
      throw new Error(`Registration error for plugin ${plugin.name}: Unsupported extension type: ${type}`);
    }
    await schema.validate(extension).catch((err) => {
      throw new Error(`Registration error for plugin ${plugin.name}: ${err}`, { cause: err });
    });
    this.extensionsEntries.push({
      plugin,
      type,
      extension
    });
  }
  async registerLegacyFactory(plugin, factory) {
    if (typeof factory?.getExtractors == "function") {
      const extractorPlugins = factory.getExtractors();
      for (const extension of extractorPlugins) {
        await this.register(plugin, "extractor", extension);
      }
    }
    if (typeof factory?.getDatabaseMappers == "function") {
      const databasePlugins = factory.getDatabaseMappers();
      for (const extension of databasePlugins) {
        await this.register(plugin, "database", extension);
      }
    }
    if (typeof factory?.getQueryPlugins == "function") {
      const queryPlugins = factory.getQueryPlugins();
      for (const extension of queryPlugins) {
        await this.register(plugin, "query", extension);
      }
    }
  }
  getSupportedExtensionTypes() {
    return Object.keys(this.schemas);
  }
  getExtensions() {
    return this.extensionsEntries;
  }
}
export {
  ExtensionRegistry
};
//# sourceMappingURL=extensionRegistry.js.map
